import { PAGE } from "#/constants";
import { AxiosResponse } from "axios";

export async function requestDecorator(
  req: Promise<AxiosResponse<any, any>>
): Promise<any> {
  try {
    const response = await req;
    return response?.data || response;
  } catch (error: any) {
    if (error.response.status === 401 || error.response.status === 403) {
      window.location.href = PAGE.NOT_AUTHENTICATED();
      return;
    }
    if (error.response.status === 404) {
      window.location.href = PAGE.NOT_FOUND();
      return;
    }
    throw error.response ?? error;
  }
}
